import { z } from "zod"

import { measuresSchema } from "./baseline"
import { intervalInfoSchema } from "./interval-info"
import { profilePropertiesSchema } from "./profile-properties"
import { readingDataSchema } from "./reading-data"
import { readingDataSummarySchema } from "./reading-data-summary"
import { sourceSchema } from "./source"

export const usageProfileSchema = z.object({
  profileId: z.string(),
  profileName: z.string().optional(),
  providerProfileId: z.string().optional(),
  accountId: z.string(),
  description: z.string().optional(),
  serviceTypes: z.string(),
  source: sourceSchema.optional(),
  isDefault: z.boolean().optional(),
  properties: profilePropertiesSchema.nullable(),
  dataStatus: z.number(),
  dataFactor: z.number().optional(),
  readingDataSummaries: z.array(readingDataSummarySchema),
  intervals: z.array(intervalInfoSchema).optional(),
  readingData: z.array(readingDataSchema).optional(),
  baselineMeasures: z.array(measuresSchema).optional().nullable(),
})

export type UsageProfile = z.infer<typeof usageProfileSchema>
